export default __webpack_public_path__ + "static/media/myself.81f3f6ce.jpg";